import React from 'react';
import html2canvas from 'html2canvas';
import moment from 'moment';
import jsPDF from 'jspdf';
import { useLocation } from 'react-router-dom';
const Ticket = () => {
	const location = useLocation();
	console.log('location', location);
	const handleDownload = () => {
		const capture = document.querySelector('.download');
		html2canvas(capture).then((canvas) => {
			const imgData = canvas.toDataURL('img/png');
			const doc = new jsPDF('p', 'mm', [450, 450]);
			const componentWidth = doc.internal.pageSize.getWidth();
			const componentHeight = doc.internal.pageSize.getHeight();
			doc.addImage(imgData, 'PNG', 0, 0, componentWidth, componentHeight);
			doc.save('ticket.pdf');
		});
	};
	console.log('selectedFlight', JSON.parse(location.state.selectedFlight));
	return (
		<div className='download'>
			<table
				style={{
					background: '#fff',
					margin: '0px auto',
					width: '850px !important',
					padding: '30px 20px',
					webkitPrintColorAdjust: 'exact',
				}}>
				<tbody>
					<tr>
						<td>
							<table
								style={{
									boxShadow: '1px 1px 15px rgba(0, 0, 0, 0.1)',
									background: '#fff',
									borderSpacing: 0,
									padding: 0,
									margin: 0,
								}}>
								<tbody>
									<tr>
										<td>
											<table
												style={{
													width: '100%',
													padding: 0,
													margin: 0,
													marginBottom: 10,
												}}>
												<tbody>
													<tr style={{ marginBottom: 10 }}>
														<td style={{ width: '60%', padding: '15px 250px' }}>
															<img
																src={
																	'https://nitish.musafirbazar.com/static/logo/HOLIDAYS.jpg'
																}
																style={{
																	maxHeight: 50,
																	maxWidth: 150,
																}}></img>
														</td>
														<td style={{ width: '40%' }}>
															<span
																style={{
																	fontWeight: 600,
																	marginTop: 5,
																}}>
																{'JDJJF'}
															</span>
															<p
																style={{
																	fontWeight: 400,
																	fontSize: 14,
																	color: '#777',
																}}>
																Email:{' '}
																{/* {agentlogin && agentlogin.result.result.email} */}
															</p>
															<p
																style={{
																	fontWeight: 400,
																	fontSize: 14,
																	color: '#777',
																}}>
																Phone: +91{' '}
																{/* {agentlogin && agentlogin.result.result.phone} */}
															</p>
															<p
																style={{
																	fontWeight: 400,
																	fontSize: 14,
																	color: '#777',
																}}>
																Address: 141st Floor,New Tech Grand, Bank More,
																Dhanbad-826001
															</p>
														</td>
													</tr>
												</tbody>
											</table>
											<table
												style={{
													width: '100%',
													padding: 0,
													margin: 0,
												}}>
												<tbody>
													<tr>
														<td
															style={{
																width: '50%',
																border: '1px solid #333',
																borderLeft: 0,
																padding: '8px',
															}}>
															<p
																style={{
																	marginBottom: '5px',
																	color: '#777',
																}}>
																<span
																	style={{
																		fontWeight: 400,
																		fontSize: 14,
																	}}>
																	Booking Time:{' '}
																	{`${moment(
																		location.state.dob.split(' ')[0]
																	).format('DD-MM-YYYY')} ${
																		location.state.dob.split(' ')[1]
																	}`}
																</span>
															</p>
															<p
																style={{
																	marginBottom: '5px',
																	color: '#777',
																}}>
																<span
																	style={{
																		fontWeight: 400,
																		fontSize: 14,
																	}}>
																	Booking ID:{''}
																	{location.state.orderId}
																</span>
															</p>
															<p
																style={{
																	marginBottom: '5px',
																	color: '#777',
																}}>
																<span
																	style={{
																		fontWeight: 400,
																		fontSize: 14,
																	}}>
																	Booking Status:
																</span>
																<span
																	style={{
																		fontWeight: 'bold',
																		fontSize: 14,
																		color: 'black',
																	}}>
																	{' '}
																	{location.state.bookingStatus}
																</span>
															</p>
														</td>
														<td
															style={{
																width: '50%',
																borderTop: '1px solid #333',
																borderBottom: '1px solid #333',
																padding: '5px',
															}}>
															<br></br>
															<table
																style={{
																	width: '100%',
																	marginBottom: '15px',
																}}>
																<tbody>
																	<tr>
																		<td style={{ width: 40 }}>
																			<p>
																				<span style={{ fontWeight: 400 }}>
																					{location.state.journeyType ===
																					'Roundtrip' ? (
																						<>
																							<img
																								src={`https://nitish.musafirbazar.com/static/media/${
																									location.state.carrier.split(
																										'|'
																									)[0]
																								}.gif`}
																								style={{
																									marginRight: 5,
																									verticalAlign: 'middle',
																									width: 50,
																									height: 50,
																								}}></img>
																							<img
																								src={`https://nitish.musafirbazar.com/static/media/${
																									location.state.carrier.split(
																										'|'
																									)[1]
																								}.gif`}
																								style={{
																									marginRight: 5,
																									verticalAlign: 'middle',
																									width: 50,
																									height: 50,
																								}}></img>
																						</>
																					) : (
																						<>
																							<img
																								src={`https://nitish.musafirbazar.com/static/media/${location.state.carrier}.gif`}
																								style={{
																									marginRight: 5,
																									verticalAlign: 'middle',
																									width: 50,
																									height: 50,
																								}}></img>
																						</>
																					)}
																				</span>
																			</p>
																		</td>
																		<td style={{ width: 40 }}>
																			<p
																				style={{
																					fontWeight: 400,
																					fontSize: 12,
																				}}>
																				{/* {ticket
																					? ticket &&
																					  ticket.result &&
																					  ticket.result.Response &&
																					  ticket.result.Response.Response &&
																					  ticket.result.Response.Response
																							.FlightItinerary.Segments[0]
																							.Airline.AirlineName
																					: bookingDetail
																					? bookingDetail.result.itemInfos.AIR
																							.tripInfos[0].sI[0].fD.aI.name
																					: ''} */}
																			</p>
																		</td>
																		<td style={{ textAlign: 'center' }}>
																			<p
																				id='pnr'
																				style={{
																					fontWeight: 'bold',
																					fontSize: 20,
																				}}>
																				<strong>
																					{location?.state?.bookingRefrence}
																				</strong>
																			</p>
																			<p>
																				<span
																					style={{
																						fontWeight: 400,
																						fontSize: 12,
																						color: '#777',
																					}}>
																					PNR
																				</span>
																			</p>
																		</td>
																	</tr>
																</tbody>
															</table>
														</td>
													</tr>
												</tbody>
											</table>
											<table
												style={{
													width: '100%',
													padding: 0,
													margin: 0,
												}}>
												<tbody>
													<tr>
														<td style={{ width: '30%' }}>
															<p
																style={{
																	background: '#000',
																	padding: '5px',
																	color: '#fff',
																	paddingLeft: 20,
																	webkitPrintColorAdjust: 'exact',
																}}>
																<span
																	style={{
																		fontWeight: 400,
																		fontSize: 14,
																	}}>
																	Flight Detail
																</span>
															</p>
														</td>
														<td style={{ width: '70%' }} align='right'>
															<p
																style={{
																	background: '#000',
																	padding: 5,
																	color: '#fff',
																	webkitPrintColorAdjust: 'exact',
																}}>
																<em>
																	<span
																		style={{
																			fontWeight: 400,
																			fontSize: 14,
																		}}>
																		*Please verify flight timings & terminal
																		info with the airlines
																	</span>
																</em>
															</p>
														</td>
													</tr>
												</tbody>
											</table>
											<table
												style={{
													width: '100%',
													lineHeight: 'normal',
													padding: 0,
													margin: 0,
												}}>
												<tbody>
													<tr>
														<td style={{ width: '20%' }}>
															<p
																style={{
																	background: '#BCBEC0',
																	color: '#000',
																	padding: '3px',
																	paddingLeft: '20px',
																	fontSize: 12,
																}}>
																<span style={{ fontWeight: 400 }}>Flight</span>
															</p>
														</td>
														<td style={{ width: '10%' }}>
															<p
																style={{
																	background: '#BCBEC0',
																	color: '#000',
																	padding: '3px',
																	paddingLeft: '20px',
																	fontSize: 12,
																}}>
																<span style={{ fontWeight: 400 }}>Class</span>
															</p>
														</td>
														<td style={{ width: '10%' }}>
															<p
																style={{
																	background: '#BCBEC0',
																	color: '#000',
																	padding: '3px',
																	paddingLeft: '20px',
																	fontSize: 12,
																}}>
																<span style={{ fontWeight: 400 }}>Stop</span>
															</p>
														</td>
														<td style={{ width: '20%' }}>
															<p
																style={{
																	background: '#BCBEC0',
																	color: '#000',
																	padding: '3px',
																	paddingLeft: '20px',
																	fontSize: 12,
																}}>
																<span style={{ fontWeight: 400 }}>
																	Departing
																</span>
															</p>
														</td>
														<td style={{ width: '20%' }}>
															<p
																style={{
																	background: '#BCBEC0',
																	color: '#000',
																	padding: '3px',
																	paddingLeft: '20px',
																	fontSize: 12,
																}}>
																<span style={{ fontWeight: 400 }}>
																	Arriving
																</span>
															</p>
														</td>
														<td style={{ width: '10%' }}>
															<p
																style={{
																	background: '#BCBEC0',
																	color: '#000',
																	padding: '3px',
																	paddingLeft: '20px',
																	fontSize: 12,
																}}>
																<span style={{ fontWeight: 400 }}>
																	Duration
																</span>
															</p>
														</td>
														<td style={{ width: '10%' }}>
															<p
																style={{
																	background: '#BCBEC0',
																	color: '#000',
																	padding: '3px',
																	paddingLeft: '20px',
																	fontSize: 12,
																}}>
																<span style={{ fontWeight: 400 }}>Baggage</span>
															</p>
														</td>
													</tr>
												</tbody>
											</table>
											<table
												style={{
													borderBottom: '1px solid #cfcbcb',
													width: '100%',
												}}>
												<tbody>
													{location.state.journeyType === 'OneWay' ? (
														<>
															{location.state.supplier === 'TBO' &&
																location?.state?.selectedFlight &&
																JSON.parse(
																	location?.state?.selectedFlight
																)?.Segments[0]?.map((item, index) => {
																	return (
																		<tr>
																			<td
																				width='20%'
																				style={{
																					padding: 2,
																					fontSize: 12,
																					paddingLeft: 20,
																				}}>
																				<p>
																					<strong style={{ color: '#000' }}>
																						{item.Airline.AirlineCode}-
																						{item.Airline.FlightNumber}
																					</strong>
																				</p>
																				<p>
																					<span style={{ fontWeight: 400 }}>
																						{item.Airline.AirlineName}
																					</span>
																				</p>
																			</td>
																			<td
																				width='10%'
																				style={{
																					padding: 2,
																					fontSize: 12,
																				}}>
																				<p>
																					<span style={{ fontWeight: 400 }}>
																						{item.Airline.FareClass}
																					</span>
																				</p>
																			</td>
																			<td width='10%'>
																				<p style={{ fontSize: 12 }}>
																					<span style={{ fontWeight: 400 }}>
																						Non Stop
																					</span>
																				</p>
																			</td>
																			<td width='20%'>
																				<p style={{ fontSize: 12 }}>
																					<strong color='#000'>
																						{`${moment(
																							item.Origin.DepTime
																						).format('DD-MM-YYYY')} ${
																							item.Origin.DepTime.split('T')[1]
																						}`}
																					</strong>
																				</p>
																				<p style={{ fontSize: 12 }}>
																					<span style={{ fontWeight: 400 }}>
																						{`${item.Origin.Airport.AirportName} (${item.Origin.Airport.AirportCode})`}
																					</span>
																				</p>
																			</td>
																			<td width='20%'>
																				<p style={{ fontSize: 12 }}>
																					<strong color='#000'>
																						{`${moment(
																							item.Destination.ArrTime
																						).format('DD-MM-YYYY')} ${
																							item.Destination.ArrTime.split(
																								'T'
																							)[1]
																						}`}
																					</strong>
																				</p>
																				<p style={{ fontSize: 12 }}>
																					<span style={{ fontWeight: 400 }}>
																						{`${item.Destination.Airport.AirportName} (${item.Destination.Airport.AirportCode})`}
																					</span>
																				</p>
																			</td>
																			<td width='10%'>
																				<p style={{ fontSize: 12 }}>
																					<strong color='#000'>
																						{`${item.Duration} min`}
																					</strong>
																				</p>
																			</td>
																			<td width='10%'>
																				<p style={{ fontSize: 12 }}>
																					<strong color='#000'>
																						{`${item?.Baggage} || ${item?.CabinBaggage} `}
																					</strong>
																				</p>
																			</td>
																		</tr>
																	);
																})}
															{location.state.supplier === 'ETR' &&
																location?.state?.selectedFlight &&
																JSON.parse(
																	location?.state?.selectedFlight
																)?.Segments?.map((item, index) => {
																	return (
																		<tr>
																			<td
																				width='20%'
																				style={{
																					padding: 2,
																					fontSize: 12,
																					paddingLeft: 20,
																				}}>
																				<p>
																					<strong style={{ color: '#000' }}>
																						{item.Airline_Code}-
																						{item.Flight_Number}
																					</strong>
																				</p>
																				<p>
																					<span style={{ fontWeight: 400 }}>
																						{item.Airline_Name}
																					</span>
																				</p>
																			</td>
																			<td
																				width='10%'
																				style={{
																					padding: 2,
																					fontSize: 12,
																				}}>
																				<p>
																					<span style={{ fontWeight: 400 }}>
																						{
																							JSON.parse(
																								location?.state?.selectedFlight
																							)?.Fares.FareDetails[0]
																								?.FareClasses[0]?.Class_Code
																						}
																					</span>
																				</p>
																			</td>
																			<td width='10%'>
																				<p style={{ fontSize: 12 }}>
																					<span style={{ fontWeight: 400 }}>
																						Non Stop
																					</span>
																				</p>
																			</td>
																			<td width='20%'>
																				<p style={{ fontSize: 12 }}>
																					<strong color='#000'>
																						{`${moment(
																							item.Departure_DateTime
																						).format('DD-MM-YYYY')} ${
																							item.Departure_DateTime.split(
																								' '
																							)[1]
																						}`}
																					</strong>
																				</p>
																				<p style={{ fontSize: 12 }}>
																					<span style={{ fontWeight: 400 }}>
																						{item.Origin}
																					</span>
																				</p>
																			</td>
																			<td width='20%'>
																				<p style={{ fontSize: 12 }}>
																					<strong color='#000'>
																						{`${moment(
																							item.Arrival_DateTime
																						).format('DD-MM-YYYY')} ${
																							item.Arrival_DateTime.split(
																								' '
																							)[1]
																						} `}
																					</strong>
																				</p>
																				<p style={{ fontSize: 12 }}>
																					<span style={{ fontWeight: 400 }}>
																						{item.Destination}
																					</span>
																				</p>
																			</td>
																			<td width='10%'>
																				<p style={{ fontSize: 12 }}>
																					<strong color='#000'>
																						{`${item.Duration} min`}
																					</strong>
																				</p>
																			</td>
																			<td width='10%'>
																				<p style={{ fontSize: 12 }}>
																					<strong color='#000'>
																						{`${
																							JSON.parse(
																								location?.state?.selectedFlight
																							)?.Fares?.FareDetails[0]
																								?.Free_Baggage?.Check_In_Baggage
																						} || ${
																							JSON.parse(
																								location?.state?.selectedFlight
																							)?.Fares?.FareDetails[0]
																								?.Free_Baggage?.Hand_Baggage
																						}`}
																					</strong>
																				</p>
																			</td>
																		</tr>
																	);
																})}
														</>
													) : (
														<>
															{location?.state?.selectedFlight.length > 1 ? (
																<>
																	{location.state.supplier === 'TBO' &&
																		location?.state?.selectedFlight &&
																		JSON.parse(
																			location?.state?.selectedFlight
																		)[0]?.Segments[0]?.map((item, index) => {
																			return (
																				<tr>
																					<td
																						width='20%'
																						style={{
																							padding: 2,
																							fontSize: 12,
																							paddingLeft: 20,
																						}}>
																						<p>
																							<strong style={{ color: '#000' }}>
																								{item.Airline.AirlineCode}-
																								{item.Airline.FlightNumber}
																							</strong>
																						</p>
																						<p>
																							<span style={{ fontWeight: 400 }}>
																								{item.Airline.AirlineName}
																							</span>
																						</p>
																					</td>
																					<td
																						width='10%'
																						style={{
																							padding: 2,
																							fontSize: 12,
																						}}>
																						<p>
																							<span style={{ fontWeight: 400 }}>
																								{item.Airline.FareClass}
																							</span>
																						</p>
																					</td>
																					<td width='10%'>
																						<p style={{ fontSize: 12 }}>
																							<span style={{ fontWeight: 400 }}>
																								Non Stop
																							</span>
																						</p>
																					</td>
																					<td width='20%'>
																						<p style={{ fontSize: 12 }}>
																							<strong color='#000'>
																								{`${moment(
																									item.Origin.DepTime
																								).format('DD-MM-YYYY')} ${
																									item.Origin.DepTime.split(
																										'T'
																									)[1]
																								}`}
																							</strong>
																						</p>
																						<p style={{ fontSize: 12 }}>
																							<span style={{ fontWeight: 400 }}>
																								{`${item.Origin.Airport.AirportName} (${item.Origin.Airport.AirportCode})`}
																							</span>
																						</p>
																					</td>
																					<td width='20%'>
																						<p style={{ fontSize: 12 }}>
																							<strong color='#000'>
																								{`${moment(
																									item.Destination.ArrTime
																								).format('DD-MM-YYYY')} ${
																									item.Destination.ArrTime.split(
																										'T'
																									)[1]
																								}`}
																							</strong>
																						</p>
																						<p style={{ fontSize: 12 }}>
																							<span style={{ fontWeight: 400 }}>
																								{`${item.Destination.Airport.AirportName} (${item.Destination.Airport.AirportCode})`}
																							</span>
																						</p>
																					</td>
																					<td width='10%'>
																						<p style={{ fontSize: 12 }}>
																							<strong color='#000'>
																								{`${item.Duration} min`}
																							</strong>
																						</p>
																					</td>
																					<td width='10%'>
																						<p style={{ fontSize: 12 }}>
																							<strong color='#000'>
																								{`${item?.Baggage} || ${item?.CabinBaggage} `}
																							</strong>
																						</p>
																					</td>
																				</tr>
																			);
																		})}
																	{location.state.supplier === 'TBO' &&
																		location?.state?.selectedFlight &&
																		JSON.parse(
																			location?.state?.selectedFlight
																		)[1]?.Segments[0]?.map((item, index) => {
																			return (
																				<tr>
																					<td
																						width='20%'
																						style={{
																							padding: 2,
																							fontSize: 12,
																							paddingLeft: 20,
																						}}>
																						<p>
																							<strong style={{ color: '#000' }}>
																								{item.Airline.AirlineCode}-
																								{item.Airline.FlightNumber}
																							</strong>
																						</p>
																						<p>
																							<span style={{ fontWeight: 400 }}>
																								{item.Airline.AirlineName}
																							</span>
																						</p>
																					</td>
																					<td
																						width='10%'
																						style={{
																							padding: 2,
																							fontSize: 12,
																						}}>
																						<p>
																							<span style={{ fontWeight: 400 }}>
																								{item.Airline.FareClass}
																							</span>
																						</p>
																					</td>
																					<td width='10%'>
																						<p style={{ fontSize: 12 }}>
																							<span style={{ fontWeight: 400 }}>
																								Non Stop
																							</span>
																						</p>
																					</td>
																					<td width='20%'>
																						<p style={{ fontSize: 12 }}>
																							<strong color='#000'>
																								{`${moment(
																									item.Origin.DepTime
																								).format('DD-MM-YYYY')} ${
																									item.Origin.DepTime.split(
																										'T'
																									)[1]
																								}`}
																							</strong>
																						</p>
																						<p style={{ fontSize: 12 }}>
																							<span style={{ fontWeight: 400 }}>
																								{`${item.Origin.Airport.AirportName} (${item.Origin.Airport.AirportCode})`}
																							</span>
																						</p>
																					</td>
																					<td width='20%'>
																						<p style={{ fontSize: 12 }}>
																							<strong color='#000'>
																								{`${moment(
																									item.Destination.ArrTime
																								).format('DD-MM-YYYY')} ${
																									item.Destination.ArrTime.split(
																										'T'
																									)[1]
																								}`}
																							</strong>
																						</p>
																						<p style={{ fontSize: 12 }}>
																							<span style={{ fontWeight: 400 }}>
																								{`${item.Destination.Airport.AirportName} (${item.Destination.Airport.AirportCode})`}
																							</span>
																						</p>
																					</td>
																					<td width='10%'>
																						<p style={{ fontSize: 12 }}>
																							<strong color='#000'>
																								{`${item.Duration} min`}
																							</strong>
																						</p>
																					</td>
																					<td width='10%'>
																						<p style={{ fontSize: 12 }}>
																							<strong color='#000'>
																								{`${item?.Baggage} || ${item?.CabinBaggage} `}
																							</strong>
																						</p>
																					</td>
																				</tr>
																			);
																		})}
																</>
															) : (
																<>
																	{location.state.supplier === 'TBO' &&
																		location?.state?.selectedFlight &&
																		JSON.parse(
																			location?.state?.selectedFlight
																		)?.Segments[0]?.map((item, index) => {
																			return (
																				<tr>
																					<td
																						width='20%'
																						style={{
																							padding: 2,
																							fontSize: 12,
																							paddingLeft: 20,
																						}}>
																						<p>
																							<strong style={{ color: '#000' }}>
																								{item.Airline.AirlineCode}-
																								{item.Airline.FlightNumber}
																							</strong>
																						</p>
																						<p>
																							<span style={{ fontWeight: 400 }}>
																								{item.Airline.AirlineName}
																							</span>
																						</p>
																					</td>
																					<td
																						width='10%'
																						style={{
																							padding: 2,
																							fontSize: 12,
																						}}>
																						<p>
																							<span style={{ fontWeight: 400 }}>
																								{item.Airline.FareClass}
																							</span>
																						</p>
																					</td>
																					<td width='10%'>
																						<p style={{ fontSize: 12 }}>
																							<span style={{ fontWeight: 400 }}>
																								Non Stop
																							</span>
																						</p>
																					</td>
																					<td width='20%'>
																						<p style={{ fontSize: 12 }}>
																							<strong color='#000'>
																								{`${moment(
																									item.Origin.DepTime
																								).format('DD-MM-YYYY')} ${
																									item.Origin.DepTime.split(
																										'T'
																									)[1]
																								}`}
																							</strong>
																						</p>
																						<p style={{ fontSize: 12 }}>
																							<span style={{ fontWeight: 400 }}>
																								{`${item.Origin.Airport.AirportName} (${item.Origin.Airport.AirportCode})`}
																							</span>
																						</p>
																					</td>
																					<td width='20%'>
																						<p style={{ fontSize: 12 }}>
																							<strong color='#000'>
																								{`${moment(
																									item.Destination.ArrTime
																								).format('DD-MM-YYYY')} ${
																									item.Destination.ArrTime.split(
																										'T'
																									)[1]
																								}`}
																							</strong>
																						</p>
																						<p style={{ fontSize: 12 }}>
																							<span style={{ fontWeight: 400 }}>
																								{`${item.Destination.Airport.AirportName} (${item.Destination.Airport.AirportCode})`}
																							</span>
																						</p>
																					</td>
																					<td width='10%'>
																						<p style={{ fontSize: 12 }}>
																							<strong color='#000'>
																								{`${item.Duration} min`}
																							</strong>
																						</p>
																					</td>
																					<td width='10%'>
																						<p style={{ fontSize: 12 }}>
																							<strong color='#000'>
																								{`${item?.Baggage} || ${item?.CabinBaggage} `}
																							</strong>
																						</p>
																					</td>
																				</tr>
																			);
																		})}
																	{location.state.supplier === 'TBO' &&
																		location?.state?.selectedFlight &&
																		JSON.parse(
																			location?.state?.selectedFlight
																		)?.Segments[1]?.map((item, index) => {
																			return (
																				<tr>
																					<td
																						width='20%'
																						style={{
																							padding: 2,
																							fontSize: 12,
																							paddingLeft: 20,
																						}}>
																						<p>
																							<strong style={{ color: '#000' }}>
																								{item.Airline.AirlineCode}-
																								{item.Airline.FlightNumber}
																							</strong>
																						</p>
																						<p>
																							<span style={{ fontWeight: 400 }}>
																								{item.Airline.AirlineName}
																							</span>
																						</p>
																					</td>
																					<td
																						width='10%'
																						style={{
																							padding: 2,
																							fontSize: 12,
																						}}>
																						<p>
																							<span style={{ fontWeight: 400 }}>
																								{item.Airline.FareClass}
																							</span>
																						</p>
																					</td>
																					<td width='10%'>
																						<p style={{ fontSize: 12 }}>
																							<span style={{ fontWeight: 400 }}>
																								Non Stop
																							</span>
																						</p>
																					</td>
																					<td width='20%'>
																						<p style={{ fontSize: 12 }}>
																							<strong color='#000'>
																								{`${moment(
																									item.Origin.DepTime
																								).format('DD-MM-YYYY')} ${
																									item.Origin.DepTime.split(
																										'T'
																									)[1]
																								}`}
																							</strong>
																						</p>
																						<p style={{ fontSize: 12 }}>
																							<span style={{ fontWeight: 400 }}>
																								{`${item.Origin.Airport.AirportName} (${item.Origin.Airport.AirportCode})`}
																							</span>
																						</p>
																					</td>
																					<td width='20%'>
																						<p style={{ fontSize: 12 }}>
																							<strong color='#000'>
																								{`${moment(
																									item.Destination.ArrTime
																								).format('DD-MM-YYYY')} ${
																									item.Destination.ArrTime.split(
																										'T'
																									)[1]
																								}`}
																							</strong>
																						</p>
																						<p style={{ fontSize: 12 }}>
																							<span style={{ fontWeight: 400 }}>
																								{`${item.Destination.Airport.AirportName} (${item.Destination.Airport.AirportCode})`}
																							</span>
																						</p>
																					</td>
																					<td width='10%'>
																						<p style={{ fontSize: 12 }}>
																							<strong color='#000'>
																								{`${item.Duration} min`}
																							</strong>
																						</p>
																					</td>
																					<td width='10%'>
																						<p style={{ fontSize: 12 }}>
																							<strong color='#000'>
																								{`${item?.Baggage} || ${item?.CabinBaggage} `}
																							</strong>
																						</p>
																					</td>
																				</tr>
																			);
																		})}
																</>
															)}
														</>
													)}
												</tbody>
											</table>
											<table style={{ marginTop: 12, width: '100%' }}>
												<tbody>
													<tr>
														<td width='100%'>
															<p
																style={{
																	background: '#000',
																	color: '#fff',
																	padding: '5px',
																	paddingLeft: '20px',
																	fontSize: 14,
																	webkitPrintColorAdjust: 'exact',
																}}>
																Passenger Details
															</p>
														</td>
													</tr>
												</tbody>
											</table>
											<table
												style={{
													color: '#000',
													width: '100%',
													verticalAlign: 'middle',
												}}>
												<tbody>
													<tr>
														<td
															style={{
																borderBottom: '1px solid #333',
																background: '#BCBEC0',
																webkitPrintColorAdjust: 'exact',
															}}>
															<p
																style={{
																	color: '#000',
																	padding: '3px',
																	fontSize: 14,
																}}>
																Sr.
															</p>
														</td>
														<td
															style={{
																borderBottom: '1px solid #333',
																background: '#BCBEC0',
																webkitPrintColorAdjust: 'exact',
															}}>
															<p
																style={{
																	color: '#000',
																	padding: '3px',
																	fontSize: 14,
																}}>
																Name
															</p>
														</td>
														<td
															style={{
																borderBottom: '1px solid #333',
																background: '#BCBEC0',
																webkitPrintColorAdjust: 'exact',
															}}>
															<p
																style={{
																	color: '#000',
																	padding: '3px',
																	fontSize: 14,
																}}>
																Type
															</p>
														</td>
														<td
															style={{
																borderBottom: '1px solid #333',
																background: '#BCBEC0',
																webkitPrintColorAdjust: 'exact',
															}}>
															<p
																style={{
																	color: '#000',
																	padding: '3px',
																	fontSize: 14,
																}}>
																PNR & Ticket No.
															</p>
														</td>
													</tr>
													{/* Passenger Details Table Start */}
													{JSON.parse(location.state.selectedPax) &&
														JSON.parse(location?.state?.selectedPax)?.map(
															(item, index) => {
																return (
																	<tr>
																		<td
																			style={{
																				borderBottom: '1px solid #333',
																				borderLeft: '1px solid #333',
																				padding: 2,
																			}}>
																			<p style={{ fontSize: 12 }}>
																				{index + 1}
																			</p>
																		</td>
																		<td
																			style={{
																				borderBottom: '1px solid #333',
																				padding: 2,
																			}}>
																			<p style={{ fontSize: 12 }}>
																				{''}
																				{`${item.title} ${item.firstname} ${item.lastname}`}
																			</p>
																		</td>
																		<td
																			style={{
																				borderBottom: '1px solid #333',
																				padding: 2,
																			}}>
																			<p
																				style={{
																					fontSize: 12,
																					fontWeight: 'bold',
																				}}>
																				{item.PaxType === 1
																					? 'Adult'
																					: item.PaxType === 2
																					? 'Child'
																					: item.PaxType === 3
																					? 'Infant'
																					: ''}
																			</p>
																		</td>
																		<td
																			style={{
																				borderBottom: '1px solid #333',
																				padding: 2,
																			}}>
																			<p
																				style={{
																					fontSize: 12,
																					fontWeight: 'bold',
																				}}>
																				{location.state.bookingRefrence}
																			</p>
																		</td>
																	</tr>
																);
															}
														)}
													{/* Passenger Details Table End */}
												</tbody>
											</table>
											<table style={{ marginTop: '12px', width: '100%' }}>
												<tbody>
													<tr>
														<td>
															<p
																style={{
																	background: '#000',
																	color: '#fff',
																	padding: '5px',
																	paddingLeft: 20,
																	fontSize: 12,
																	webkitPrintColorAdjust: 'exact',
																}}>
																Contact Details
															</p>
														</td>
													</tr>
												</tbody>
											</table>
											<table
												style={{
													border: '1px solid #333',
													width: '100%',
												}}>
												<tbody>
													<tr>
														<td
															style={{
																padding: 3,
																fontSize: 12,
																color: '#000',
																paddingLeft: '20px',
																fontWeight: 'bold',
															}}>
															Phone: +91 {location.state.userPhone}
														</td>
														<td
															style={{
																padding: 3,
																fontWeight: 'bold',
															}}>
															<p>Email: {location.state.userEmail}</p>
														</td>
													</tr>
												</tbody>
											</table>
											<table style={{ marginTop: '12px', width: '100%' }}>
												<tbody>
													<tr>
														<td>
															<p
																style={{
																	background: '#000',
																	color: '#fff',
																	padding: '5px',
																	paddingLeft: 20,
																	fontSize: 12,
																	webkitPrintColorAdjust: 'exact',
																}}>
																Fare Details
															</p>
														</td>
													</tr>
												</tbody>
											</table>{' '}
											<table
												style={{
													border: '1px solid #333',
													width: '100%',
												}}>
												<tbody>
													<tr>
														<td
															style={{
																padding: 3,
																fontSize: 12,
																color: '#000',
																paddingLeft: '20px',
															}}>
															Total Price
														</td>
														<td
															style={{
																padding: 3,
																fontWeight: 'bold',
															}}>
															<p>INR 87459</p>
														</td>
													</tr>
												</tbody>
											</table>
											<table style={{ marginTop: 12, width: '100%' }}>
												<tbody>
													<tr>
														<td>
															<p
																style={{
																	background: '#000',
																	color: '#fff',
																	padding: '5px',
																	paddingLeft: '20px',
																	fontSize: 12,
																	webkitPrintColorAdjust: 'exact',
																}}>
																Important Information
															</p>
														</td>
													</tr>
												</tbody>
											</table>
											<table
												style={{
													width: '100%',
													marginBottom: '40px',
													paddingTop: '15px',
												}}>
												<tbody>
													<tr>
														<td
															style={{
																padding: '0 8px',
																fontSize: 13,
																color: '#000',
																width: '100%',
															}}>
															1 - You must web check-in on the airline website
															and obtain a boarding pass.
														</td>
													</tr>
													<tr>
														<td
															style={{
																padding: '0 8px',
																fontSize: 13,
																color: '#000',
																width: '100%',
															}}>
															2 - You must download & register on the Aarogya
															Setu App and carry a Valid ID
														</td>
													</tr>
													<tr>
														<td
															style={{
																padding: '0 8px',
																fontSize: 13,
																color: '#000',
																width: '100%',
															}}>
															3 - It is mandatory to wear a musk and carry other
															protective gear.
														</td>
													</tr>
													<tr>
														<td
															style={{
																padding: '0 8px',
																fontSize: 13,
																color: '#000',
																width: '100%',
															}}>
															4 - Reach the terminal at least 2 hours prior to
															the departure for domestic flight and 4 hors prior
															to the departure of international flight .
														</td>
													</tr>
													<tr>
														<td
															style={{
																padding: '0 8px',
																fontSize: 13,
																color: '#000',
																width: '100%',
															}}>
															5 - For departure terminal please check with the
															airline first.
														</td>
													</tr>
													<tr>
														<td
															style={{
																padding: '0 8px',
																fontSize: 13,
																color: '#000',
																width: '100%',
															}}>
															6 - Date & Time is calculated based on the local
															time of the city/destination.
														</td>
													</tr>
													<tr>
														<td
															style={{
																padding: '0 8px',
																fontSize: 13,
																color: '#000',
																width: '100%',
															}}>
															7 - Use the Airline PNR for all Correspondence
															directly with the Airline.
														</td>
													</tr>
													<tr>
														<td
															style={{
																padding: '0 8px',
																fontSize: 13,
																color: '#000',
																width: '100%',
															}}>
															8 - For rescheduling/cancellation within 4hours of
															the departure time contact the airline directly.
														</td>
													</tr>
													<tr>
														<td
															style={{
																padding: '0 8px',
																fontSize: 13,
																color: '#000',
																width: '100%',
															}}>
															9 - Your ability to travel is at the sole
															discretion of the airport authorities and we shall
															not be held responsible.
														</td>
													</tr>
												</tbody>
											</table>
										</td>
									</tr>
								</tbody>
							</table>
						</td>
					</tr>
				</tbody>
			</table>
			<button onClick={handleDownload}>Download</button>
		</div>
	);
};

export default Ticket;
